import { render, staticRenderFns } from "./PreviewTestimonials.vue?vue&type=template&id=d094e81a"
import script from "./PreviewTestimonials.vue?vue&type=script&lang=js"
export * from "./PreviewTestimonials.vue?vue&type=script&lang=js"
import style0 from "./PreviewTestimonials.vue?vue&type=style&index=0&id=d094e81a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VCard,VImg})
